import { LazyModule, createLazyComponent } from 'owa-bundling';
import { ComponentClass } from 'react';
import * as spItemsView from './lazyIndex';

const lazyModuleSPItemsView = new LazyModule<typeof spItemsView>(() =>
    import(/* webpackChunkName: "gfh-itemsview" */ './lazyIndex')
);

export const LazySPItemsViewCommandBar = createLazyComponent<{}, typeof spItemsView>(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewCommandBar
);

export const LazySPItemsViewErrorComponent = createLazyComponent<{}, typeof spItemsView>(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewErrorComponent
);

export const LazySPItemsViewList = createLazyComponent<{}, typeof spItemsView>(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewList
);

export const LazySPItemsViewNavigator = createLazyComponent<{}, typeof spItemsView>(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewNavigator
);

export const LazySPItemsViewRefreshComponent = createLazyComponent<{}, typeof spItemsView>(
    lazyModuleSPItemsView,
    m => m.SharepointItemsViewRefreshComponent
);

export type __unused_declarations = ComponentClass;
